import { create } from "zustand";
import { UniversalSearchStore } from "./types";

const useUniversalSearchStore = create<UniversalSearchStore>((set, get) => ({
  patient: null,
  setPatient: patient => set({ patient }),
}));

export default useUniversalSearchStore;
